export const SET_ALERT = 1
export const SET_SERVER_STATUS = 2
export const LOAD_DICTIONARY = 3
export const LOGIN = 4
export const LOGOUT = 5
export const SET_BOOKINGS = 6
export const UPDATE_BOOKING = 7
export const SET_TRANSFERS = 8
export const UPDATE_TRANSFER = 9
export const UPDATE_TRANSFER_PRICE = 10
export const UPDATE_SIMCARD = 11
